import React, { Component } from "react";
import Header from "../../Content/Header/Header";
import { Redirect } from "react-router-dom";
import { checkCookie } from "../../Utils/Utils";
import { Card } from "react-bootstrap";
import { SNACK_SHACK } from "../../../constants/Constants";
require("./booth.scss");

class SnackShack extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    return (
      <div className="booth-container">
        <Header />
        <div className="booth-title">Snack Shack</div>
        <Card.Img className="booth-image" src="/indian-snacks.png" />
        <Card.Title className="booth-text">ITEMS AVAILABLE</Card.Title>
        {SNACK_SHACK.map(items => (
          <Card.Text className="booth-item">{items}</Card.Text>
        ))}
      </div>
    );
  }
}

export default SnackShack;
